import { Box, Typography, Button, Divider, Grid, useMediaQuery, Container, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Navigation } from "./navigation";
import { Footer } from "./Footer";
import HomeSection2 from "./homepage/RatingSection";
import FacultySection from "./homepage/FacultyList";
import IframFormSection from "./homepage/IframeSection";
import instId from "./network/instituteId";
import axios from "axios";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SecurityIcon from '@mui/icons-material/Security';
import { BASE_URL } from "./network/endpoints";

// Add CSS animations
const globalStyles = `
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(50px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @keyframes slideInLeft {
        from {
            opacity: 0;
            transform: translateX(-80px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
    
    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.7);
        }
        50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(102, 126, 234, 0);
        }
    }
    
    @keyframes float {
        0%, 100% {
            transform: translateY(0px) rotate(0deg);
        }
        50% {
            transform: translateY(-15px) rotate(5deg);
        }
    }
    
    @keyframes shimmer {
        0% {
            background-position: -1200px 0;
        }
        100% {
            background-position: 1200px 0;
        }
    }
    
    @keyframes bounceIn {
        0% {
            opacity: 0;
            transform: scale(0.2) rotate(-45deg);
        }
        50% {
            opacity: 1;
            transform: scale(1.15) rotate(10deg);
        }
        100% {
            opacity: 1;
            transform: scale(1) rotate(0deg);
        }
    }
    
    @keyframes glow {
        0%, 100% {
            box-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
        }
        50% {
            box-shadow: 0 0 40px rgba(102, 126, 234, 0.6);
        }
    }
    
    @keyframes morphBackground {
        0%, 100% {
            border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
        }
        50% {
            border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
        }
    }
`;

// Inject styles
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = globalStyles;
    document.head.appendChild(styleSheet);
}

const TermsAndConditions = () => {

    const isMobile = useMediaQuery("(min-width:600px)");
    const [Endpoints, setEndpoints] = useState('')

    useEffect(() => {
        window.scrollTo(0, 0);
        getInstituteDetail();
    }, []);

    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {
                setEndpoints(response?.data?.instituteTechSetting?.mediaUrl)
                // Endpoints = response?.data?.instituteTechSetting?.mediaUrl
            };
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <React.Fragment>
            {/* Modern Background with Gradient */}
            <Box sx={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #667eea 100%)',
                minHeight: '100vh',
                pt: { xs: 8,sm: 8},
                pb: { xs:4,sm: 4},
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: '-50%',
                    left: '-50%',
                    width: '200%',
                    height: '200%',
                    background: 'radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(118, 75, 162, 0.2) 0%, transparent 50%), radial-gradient(circle at 50% 50%, rgba(102, 126, 234, 0.1) 0%, transparent 70%)',
                    animation: 'morphBackground 15s ease-in-out infinite, float 8s ease-in-out infinite',
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.03) 50%, transparent 70%)',
                    backgroundSize: '400% 400%',
                    animation: 'shimmer 4s linear infinite',
                },
            }}>
                {/* Floating Background Elements */}
                <Box sx={{
                    position: 'absolute',
                    top: '10%',
                    right: '10%',
                    width: '100px',
                    height: '100px',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                    borderRadius: '50%',
                    animation: 'float 6s ease-in-out infinite',
                    zIndex: 0,
                }}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '60%',
                        height: '60%',
                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(118, 75, 162, 0.3) 100%)',
                        borderRadius: '50%',
                        animation: 'pulse 3s ease-in-out infinite',
                    }} />
                </Box>

                <Box sx={{
                    position: 'absolute',
                    bottom: '20%',
                    left: '5%',
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)',
                    borderRadius: '50%',
                    animation: 'float 8s ease-in-out infinite reverse',
                    zIndex: 0,
                }} />

                {/* Main Content Container */}
                <Container 
                    maxWidth="lg" 
                    sx={{ 
                        position: 'relative',
                        zIndex: 1,
                    }}
                >
                    {/* Hero Section */}
                    <Box sx={{ 
                        textAlign: 'center', 
                        mb: { xs: 6, sm: 8 },
                        animation: 'fadeInUp 1s ease-out',
                    }}>
                        <Box sx={{
                            display: 'inline-block',
                            background: 'linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%)',
                            backdropFilter: 'blur(20px)',
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: '50px',
                            px: 4,
                            py: 1,
                            mb: 3,
                        }}>
                            <Typography sx={{
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '14px',
                                fontWeight: 600,
                                letterSpacing: '2px',
                                textTransform: 'uppercase',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}>
                                <SecurityIcon sx={{ fontSize: '16px' }} />
                                Legal Information
                            </Typography>
                        </Box>

                        <Typography 
                            variant="h1" 
                            sx={{ 
                                fontWeight: 900,
                                background: 'linear-gradient(135deg, #ffffff 0%, #f0f4ff 50%, #ffffff 100%)',
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                mb: 3,
                                fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' },
                                lineHeight: 1.1,
                                textShadow: '0 10px 30px rgba(0,0,0,0.3)',
                                letterSpacing: '-0.02em',
                            }}
                        >
                            Terms &
                            <br />
                            <span style={{
                                background: 'linear-gradient(135deg, #ff6b6b 0%, #ffd93d 50%, #6bcf7f 100%)',
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}>
                                Conditions
                            </span>
                        </Typography>
                        
                        <Typography 
                            variant="h5" 
                            sx={{ 
                                color: 'rgba(255,255,255,0.85)',
                                maxWidth: '600px',
                                mx: 'auto',
                                fontSize: { xs: '1.1rem', sm: '1.3rem' },
                                lineHeight: 1.6,
                                fontWeight: 400,
                                textShadow: '0 2px 10px rgba(0,0,0,0.2)',
                            }}
                        >
                            📋 Please read our terms and conditions carefully before using our services
                        </Typography>
                    </Box>

                    {/* Terms Card */}
                    <Card sx={{
                        background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 100%)',
                        backdropFilter: 'blur(30px)',
                        border: '2px solid rgba(255,255,255,0.8)',
                        borderRadius: '30px',
                        overflow: 'hidden',
                        boxShadow: '0 30px 80px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
                        animation: 'slideInLeft 1s ease-out 0.3s both',
                        position: 'relative',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
                            animation: 'shimmer 3s linear infinite',
                            zIndex: 0,
                        },
                    }}>
                        <Box sx={{ 
                            p: { xs: 4, sm: 6, md: 8 },
                            position: 'relative',
                            zIndex: 1,
                        }}>
                            {/* Card Header */}
                            <Box sx={{ mb: 6, textAlign: 'center' }}>
                                <SecurityIcon sx={{ 
                                    fontSize: '3rem', 
                                    color: '#667eea',
                                    mb: 2,
                                    filter: 'drop-shadow(0 4px 12px rgba(102, 126, 234, 0.3))',
                                }} />
                                <Typography 
                                    variant="h2" 
                                    sx={{ 
                                        fontWeight: 800,
                                        color: "#2c2c2c",
                                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                                        lineHeight: 1.2,
                                        textShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        letterSpacing: '-0.02em',
                                        mb: 2,
                                    }}
                                >
                                    Terms and Conditions
                                </Typography>
                                <Typography sx={{
                                    color: '#666',
                                    fontSize: { xs: '1rem', sm: '1.1rem' },
                                    maxWidth: '500px',
                                    mx: 'auto',
                                }}>
                                    By using our services, you agree to the following terms and conditions
                                </Typography>
                            </Box>

                            {/* Terms List */}
                            <Box component="ul" sx={{ 
                                listStyle: 'none',
                                p: 0,
                                m: 0,
                                '& li': {
                                    animation: 'fadeInUp 0.8s ease-out',
                                    animationFillMode: 'both',
                                },
                            }}>
                                {[
                                    "Admission once taken will not be cancelled at any cost",
                                    "Please be careful while selecting Test Series Subjects and Plan suitable for you. Later on no alterations will be done.",
                                    "The Test Series Purchased would be valid only for the attempt for which you have taken it.",
                                    "Please note in case of genuine reason only extension for test series will be provided that too only for one Attempt. (6 months)",
                                    "Refund of fees will not be provided for any reason other than Medical Emergency subject to documentation.",
                                    "Refund process would take 15 days after due procedure completed from students end.",
                                    "Please note the Pattern and Portion of Test Series is designed after due analysis of Past Papers.",
                                    "Please watch a video of How to Buy Test Series before buying any Test Series in order to avoid Confusion."
                                ].map((term, index) => (
                                    <Box 
                                        component="li" 
                                        key={index}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            mb: 4,
                                            p: 3,
                                            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(102, 126, 234, 0.04) 100%)',
                                            borderRadius: '20px',
                                            border: '1px solid rgba(102, 126, 234, 0.1)',
                                            transition: 'all 0.3s ease',
                                            animationDelay: `${index * 0.1}s`,
                                            '&:hover': {
                                                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.12) 0%, rgba(102, 126, 234, 0.08) 100%)',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 10px 30px rgba(102, 126, 234, 0.2)',
                                            },
                                        }}
                                    >
                                        <CheckCircleIcon 
                                            sx={{ 
                                                color: '#667eea',
                                                fontSize: '1.5rem',
                                                mr: 3,
                                                mt: 0.5,
                                                flexShrink: 0,
                                                filter: 'drop-shadow(0 2px 4px rgba(102, 126, 234, 0.3))',
                                            }} 
                                        />
                                        <Typography sx={{
                                            color: '#333333',
                                            fontSize: { xs: '1rem', sm: '1.1rem' },
                                            lineHeight: 1.7,
                                            fontWeight: 400,
                                        }}>
                                            {term}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                            {/* Footer Note */}
                            <Box sx={{
                                mt: 6,
                                p: 4,
                                background: 'linear-gradient(135deg, rgba(255, 107, 107, 0.1) 0%, rgba(255, 107, 107, 0.05) 100%)',
                                borderRadius: '20px',
                                border: '1px solid rgba(255, 107, 107, 0.2)',
                                textAlign: 'center',
                            }}>
                                <Typography sx={{
                                    color: '#d32f2f',
                                    fontSize: { xs: '0.9rem', sm: '1rem' },
                                    fontWeight: 600,
                                    mb: 1,
                                }}>
                                    ⚠️ Important Notice
                                </Typography>
                                <Typography sx={{
                                    color: '#666',
                                    fontSize: { xs: '0.85rem', sm: '0.95rem' },
                                    lineHeight: 1.6,
                                }}>
                                    These terms and conditions are subject to change without prior notice. 
                                    Please review them periodically for updates.
                                </Typography>
                            </Box>
                        </Box>
                    </Card>
                </Container>
            </Box>
        </React.Fragment>
    );
};

export default TermsAndConditions;
